module.exports = __webpack_public_path__ + "img/quote3.ba32db7a.jpg";